<form #container class="k-form k-form-horizontal" style="max-width: 700px;width: 700px;" [formGroup]="formGroup">
  <fieldset class="k-form-fieldset">

    <!-- Notas -->
    <kendo-formfield orientation="horizontal">
      <kendo-label class="k-label" [for]="notas" [text]="customMsgService.translate('notas')"> </kendo-label>
      <kendo-textbox formControlName="notas" [clearButton]="true" #notas required> </kendo-textbox>
      <kendo-formerror> {{ customMsgService.translate('error') }}: {{ customMsgService.translate('theField') }} {{
        customMsgService.translate('notas') }} {{ customMsgService.translate('isRequired') }}</kendo-formerror>
    </kendo-formfield>

    <!-- Estado -->
    <kendo-formfield orientation="horizontal">
      <kendo-label class="k-label" [for]="estado" [text]="customMsgService.translate('state')"> </kendo-label>
      <kendo-dropdownlist formControlName="estado" textField="description" valueField="id" [data]="lEstadosAlerta" #estado required>
      </kendo-dropdownlist>
      <kendo-formerror> {{ customMsgService.translate('error') }}: {{ customMsgService.translate('theField') }} {{
        customMsgService.translate('state') }} {{ customMsgService.translate('isRequired') }}</kendo-formerror>
    </kendo-formfield>

  </fieldset>

  <hr />
  <div class="k-form-buttons">
    <!-- Botão de Cancelar -->
    <button kendoButton (click)="cancelChanges()">
      {{ customMsgService.translate('cancel') }}
    </button>

    <!-- Botão de Guardar -->
    <button kendoButton [primary]="true" [disabled]="formGroup.invalid || formGroup.pristine" (click)="saveChanges()">
      {{ customMsgService.translate('saveChanges') }}
    </button>
  </div>
</form>
